import React from 'react';
import { Container, Paper, Box, Typography, Stack } from '@mui/material';
import ListaAvisos from '../components/avisos/ListaAvisos';
import { AvisoProvider } from '../contexts/AvisoContext';
import AtualizacoesTempoRealToggle from '../components/AtualizacoesTempoRealToggle';

const Avisos: React.FC = () => {
  return (
    <AvisoProvider>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="h6" component="h2">
              Avisos
            </Typography>
            <AtualizacoesTempoRealToggle />
          </Stack>
          <Box sx={{ width: '100%' }}>
            <ListaAvisos />
          </Box>
        </Paper>
      </Container>
    </AvisoProvider>
  );
};

export default Avisos;
